import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import ProductSales from "./product-sales";
import ModifiersSales from "./modifier-sales";
import Sales from "./sales";
import { oneBranchHasPermission } from "src/utils";
import { SalesPermissions } from "src/constants/permissions";
import NoAccessPage from "src/pages/no-access";
import { SecondaryTabPanel } from "src/shared/components/tabs/secondary-tabs-panel";
import { getTabA11yProps } from "src/shared/components/tabs/tab-props";

const SalesTabs = () => {
  const [value, setValue] = useState(0);
  const { t: salesT } = useTranslation("addSales");
  const { t: settingT } = useTranslation("settings");

  const viewSales = oneBranchHasPermission(SalesPermissions.viewSales);
  const viewProductSales = oneBranchHasPermission(
    SalesPermissions.viewProductSales,
  );
  const viewModifiersSales = oneBranchHasPermission(
    SalesPermissions.viewModifierSales,
  );

  const labels = [
    settingT("salesPos"),
    ...(viewProductSales ? [salesT("productSales")] : []),
    ...(viewModifiersSales ? [salesT("modifierSales")] : []),
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs value={value} onChange={handleChange}>
        {labels.map((label, index) => {
          return (
            <Tab
              disableRipple
              key={`${index}_${label}`}
              label={label}
              {...getTabA11yProps(index)}
            />
          );
        })}
      </Tabs>

      <Box mt={{ xs: "-20px", md: "-65px" }}>
        <SecondaryTabPanel value={value} index={0}>
          {viewSales ? <Sales /> : <NoAccessPage />}
        </SecondaryTabPanel>
        <SecondaryTabPanel value={value} index={1}>
          {viewProductSales ? <ProductSales /> : <NoAccessPage />}
        </SecondaryTabPanel>
        <SecondaryTabPanel value={value} index={2}>
          {viewModifiersSales ? <ModifiersSales /> : <NoAccessPage />}
        </SecondaryTabPanel>
      </Box>
    </Box>
  );
};

export default SalesTabs;
